/* eslint-disable @typescript-eslint/naming-convention */
var BxfIconTypeEnum;
(function (BxfIconTypeEnum) {
    BxfIconTypeEnum["fill"] = "fill";
    BxfIconTypeEnum["text"] = "text";
    BxfIconTypeEnum["API"] = "API";
    BxfIconTypeEnum["account"] = "account";
    BxfIconTypeEnum["action-12"] = "action-12";
    BxfIconTypeEnum["action"] = "action";
    BxfIconTypeEnum["actionarrow-back"] = "actionarrow-back";
    BxfIconTypeEnum["actionarrow-down"] = "actionarrow-down";
    BxfIconTypeEnum["actionarrow-forward"] = "actionarrow-forward";
    BxfIconTypeEnum["actionarrow-up"] = "actionarrow-up";
    BxfIconTypeEnum["add"] = "add";
    BxfIconTypeEnum["alert-2"] = "alert-2";
    BxfIconTypeEnum["alert-bell-subtle"] = "alert-bell-subtle";
    BxfIconTypeEnum["alert-bell"] = "alert-bell";
    BxfIconTypeEnum["alert-bold-large"] = "alert-bold-large";
    BxfIconTypeEnum["alert-bold"] = "alert-bold";
    BxfIconTypeEnum["alert-subtle-large"] = "alert-subtle-large";
    BxfIconTypeEnum["alert-subtle"] = "alert-subtle";
    BxfIconTypeEnum["alert"] = "alert";
    BxfIconTypeEnum["align-center"] = "align-center";
    BxfIconTypeEnum["align-left"] = "align-left";
    BxfIconTypeEnum["align-right"] = "align-right";
    BxfIconTypeEnum["analysis-result"] = "analysis-result";
    BxfIconTypeEnum["arrow-down"] = "arrow-down";
    BxfIconTypeEnum["arrow-dropdown-up"] = "arrow-dropdown-up";
    BxfIconTypeEnum["arrow-dropdown"] = "arrow-dropdown";
    BxfIconTypeEnum["arrow-left"] = "arrow-left";
    BxfIconTypeEnum["arrow-right"] = "arrow-right";
    BxfIconTypeEnum["arrow-up"] = "arrow-up";
    BxfIconTypeEnum["back-arrow"] = "back-arrow";
    BxfIconTypeEnum["bookmark-bold"] = "bookmark-bold";
    BxfIconTypeEnum["bookmark-subtle"] = "bookmark-subtle";
    BxfIconTypeEnum["briefcase"] = "briefcase";
    BxfIconTypeEnum["buy"] = "buy";
    BxfIconTypeEnum["bxf-arrow-right"] = "bxf-arrow-right";
    BxfIconTypeEnum["bxf-beta"] = "bxf-beta";
    BxfIconTypeEnum["bxf-calendar"] = "bxf-calendar";
    BxfIconTypeEnum["bxf-caution"] = "bxf-caution";
    BxfIconTypeEnum["bxf-caution48"] = "bxf-caution48";
    BxfIconTypeEnum["bxf-chat-blk-beta"] = "bxf-chat-blk-beta";
    BxfIconTypeEnum["bxf-chat"] = "bxf-chat";
    BxfIconTypeEnum["bxf-clear"] = "bxf-clear";
    BxfIconTypeEnum["bxf-close"] = "bxf-close";
    BxfIconTypeEnum["bxf-contact"] = "bxf-contact";
    BxfIconTypeEnum["bxf-copy"] = "bxf-copy";
    BxfIconTypeEnum["bxf-dismiss"] = "bxf-dismiss";
    BxfIconTypeEnum["bxf-double-down"] = "bxf-double-down";
    BxfIconTypeEnum["bxf-double-up"] = "bxf-double-up";
    BxfIconTypeEnum["bxf-email"] = "bxf-email";
    BxfIconTypeEnum["bxf-exit-full-screen"] = "bxf-exit-full-screen";
    BxfIconTypeEnum["bxf-full-screen"] = "bxf-full-screen";
    BxfIconTypeEnum["bxf-history"] = "bxf-history";
    BxfIconTypeEnum["bxf-kebab-menu"] = "bxf-kebab-menu";
    BxfIconTypeEnum["bxf-link-external"] = "bxf-link-external";
    BxfIconTypeEnum["bxf-loading"] = "bxf-loading";
    BxfIconTypeEnum["bxf-loading48"] = "bxf-loading48";
    BxfIconTypeEnum["bxf-logo-large"] = "bxf-logo-large";
    BxfIconTypeEnum["bxf-nav-active"] = "bxf-nav-active";
    BxfIconTypeEnum["bxf-nav-inactive"] = "bxf-nav-inactive";
    BxfIconTypeEnum["bxf-new-chat"] = "bxf-new-chat";
    BxfIconTypeEnum["bxf-panel-logo"] = "bxf-panel-logo";
    BxfIconTypeEnum["bxf-pdf"] = "bxf-pdf";
    BxfIconTypeEnum["bxf-phone"] = "bxf-phone";
    BxfIconTypeEnum["bxf-send"] = "bxf-send";
    BxfIconTypeEnum["bxf-sparkle-large"] = "bxf-sparkle-large";
    BxfIconTypeEnum["bxf-sparkle"] = "bxf-sparkle";
    BxfIconTypeEnum["bxf-stop"] = "bxf-stop";
    BxfIconTypeEnum["bxf-thumbs-down"] = "bxf-thumbs-down";
    BxfIconTypeEnum["bxf-thumbs-up"] = "bxf-thumbs-up";
    BxfIconTypeEnum["calendar"] = "calendar";
    BxfIconTypeEnum["cards"] = "cards";
    BxfIconTypeEnum["chat-attachment"] = "chat-attachment";
    BxfIconTypeEnum["chat-microphone"] = "chat-microphone";
    BxfIconTypeEnum["chat-new"] = "chat-new";
    BxfIconTypeEnum["chat-submit"] = "chat-submit";
    BxfIconTypeEnum["checkbox-mixed-state-2"] = "checkbox-mixed-state-2";
    BxfIconTypeEnum["checkmark"] = "checkmark";
    BxfIconTypeEnum["clear"] = "clear";
    BxfIconTypeEnum["clone"] = "clone";
    BxfIconTypeEnum["copilot-20"] = "copilot-20";
    BxfIconTypeEnum["copilot-32"] = "copilot-32";
    BxfIconTypeEnum["copilot-64"] = "copilot-64";
    BxfIconTypeEnum["copilot"] = "copilot";
    BxfIconTypeEnum["copy-to-clipboard"] = "copy-to-clipboard";
    BxfIconTypeEnum["data-custom-sort"] = "data-custom-sort";
    BxfIconTypeEnum["data-filter-a-z"] = "data-filter-a-z";
    BxfIconTypeEnum["data-filter-large-small"] = "data-filter-large-small";
    BxfIconTypeEnum["data-filter-small-large"] = "data-filter-small-large";
    BxfIconTypeEnum["data-filter-z-a"] = "data-filter-z-a";
    BxfIconTypeEnum["data-select-arrow-down"] = "data-select-arrow-down";
    BxfIconTypeEnum["data-select-arrow-up"] = "data-select-arrow-up";
    BxfIconTypeEnum["data-select-caret-down"] = "data-select-caret-down";
    BxfIconTypeEnum["data-select-caret-up"] = "data-select-caret-up";
    BxfIconTypeEnum["delete-small"] = "delete-small";
    BxfIconTypeEnum["delete-trash"] = "delete-trash";
    BxfIconTypeEnum["delete"] = "delete";
    BxfIconTypeEnum["detail"] = "detail";
    BxfIconTypeEnum["did-not-run"] = "did-not-run";
    BxfIconTypeEnum["download"] = "download";
    BxfIconTypeEnum["draw-arrow"] = "draw-arrow";
    BxfIconTypeEnum["draw-ellipse"] = "draw-ellipse";
    BxfIconTypeEnum["draw-freeform"] = "draw-freeform";
    BxfIconTypeEnum["draw-rectangle"] = "draw-rectangle";
    BxfIconTypeEnum["drawer-left"] = "drawer-left";
    BxfIconTypeEnum["drawer-right"] = "drawer-right";
    BxfIconTypeEnum["duplicate"] = "duplicate";
    BxfIconTypeEnum["edit"] = "edit";
    BxfIconTypeEnum["ellipsis"] = "ellipsis";
    BxfIconTypeEnum["error-bold"] = "error-bold";
    BxfIconTypeEnum["error-subtle-2"] = "error-subtle-2";
    BxfIconTypeEnum["error-subtle"] = "error-subtle";
    BxfIconTypeEnum["excel"] = "excel";
    BxfIconTypeEnum["export"] = "export";
    BxfIconTypeEnum["eye"] = "eye";
    BxfIconTypeEnum["favorite-bold-32"] = "favorite-bold-32";
    BxfIconTypeEnum["favorite-bold"] = "favorite-bold";
    BxfIconTypeEnum["favorite-subtle"] = "favorite-subtle";
    BxfIconTypeEnum["file"] = "file";
    BxfIconTypeEnum["filter-subtle"] = "filter-subtle";
    BxfIconTypeEnum["filter"] = "filter";
    BxfIconTypeEnum["folder-subtle"] = "folder-subtle";
    BxfIconTypeEnum["folder"] = "folder";
    BxfIconTypeEnum["globe"] = "globe";
    BxfIconTypeEnum["gripper"] = "gripper";
    BxfIconTypeEnum["help-bold"] = "help-bold";
    BxfIconTypeEnum["help-subtle"] = "help-subtle";
    BxfIconTypeEnum["help"] = "help";
    BxfIconTypeEnum["icon-detail"] = "icon-detail";
    BxfIconTypeEnum["icon-list"] = "icon-list";
    BxfIconTypeEnum["icon-widget-table"] = "icon-widget-table";
    BxfIconTypeEnum["icon-widget-visualization"] = "icon-widget-visualization";
    BxfIconTypeEnum["important-quotes"] = "important-quotes";
    BxfIconTypeEnum["info-2"] = "info-2";
    BxfIconTypeEnum["info-bold-large"] = "info-bold-large";
    BxfIconTypeEnum["info-bold"] = "info-bold";
    BxfIconTypeEnum["info-subtle-large"] = "info-subtle-large";
    BxfIconTypeEnum["info-subtle"] = "info-subtle";
    BxfIconTypeEnum["info"] = "info";
    BxfIconTypeEnum["inprogress-2"] = "inprogress-2";
    BxfIconTypeEnum["inprogress-bold-large"] = "inprogress-bold-large";
    BxfIconTypeEnum["inprogress-bold"] = "inprogress-bold";
    BxfIconTypeEnum["inprogress-subtle-large"] = "inprogress-subtle-large";
    BxfIconTypeEnum["inprogress-subtle"] = "inprogress-subtle";
    BxfIconTypeEnum["launch"] = "launch";
    BxfIconTypeEnum["layout"] = "layout";
    BxfIconTypeEnum["lightbulb"] = "lightbulb";
    BxfIconTypeEnum["like"] = "like";
    BxfIconTypeEnum["link"] = "link";
    BxfIconTypeEnum["list"] = "list";
    BxfIconTypeEnum["livechat"] = "livechat";
    BxfIconTypeEnum["loading"] = "loading";
    BxfIconTypeEnum["lock"] = "lock";
    BxfIconTypeEnum["log-in"] = "log-in";
    BxfIconTypeEnum["log-out"] = "log-out";
    BxfIconTypeEnum["mail"] = "mail";
    BxfIconTypeEnum["maximize"] = "maximize";
    BxfIconTypeEnum["menu"] = "menu";
    BxfIconTypeEnum["merge"] = "merge";
    BxfIconTypeEnum["mine"] = "mine";
    BxfIconTypeEnum["minimize"] = "minimize";
    BxfIconTypeEnum["monitor"] = "monitor";
    BxfIconTypeEnum["more-options"] = "more-options";
    BxfIconTypeEnum["move-all-down"] = "move-all-down";
    BxfIconTypeEnum["move-all-left"] = "move-all-left";
    BxfIconTypeEnum["move-all-right"] = "move-all-right";
    BxfIconTypeEnum["move-all-selected"] = "move-all-selected";
    BxfIconTypeEnum["move-all-unselected"] = "move-all-unselected";
    BxfIconTypeEnum["move-all-up"] = "move-all-up";
    BxfIconTypeEnum["move-folder"] = "move-folder";
    BxfIconTypeEnum["nested"] = "nested";
    BxfIconTypeEnum["new-2"] = "new-2";
    BxfIconTypeEnum["new-3"] = "new-3";
    BxfIconTypeEnum["new-bold-large"] = "new-bold-large";
    BxfIconTypeEnum["new-bold"] = "new-bold";
    BxfIconTypeEnum["new-subtle-large"] = "new-subtle-large";
    BxfIconTypeEnum["new-subtle"] = "new-subtle";
    BxfIconTypeEnum["open-order"] = "open-order";
    BxfIconTypeEnum["pause"] = "pause";
    BxfIconTypeEnum["phone"] = "phone";
    BxfIconTypeEnum["pin"] = "pin";
    BxfIconTypeEnum["play"] = "play";
    BxfIconTypeEnum["popin"] = "popin";
    BxfIconTypeEnum["popout"] = "popout";
    BxfIconTypeEnum["print"] = "print";
    BxfIconTypeEnum["progress-active-large"] = "progress-active-large";
    BxfIconTypeEnum["progress-active"] = "progress-active";
    BxfIconTypeEnum["progress-empty-large"] = "progress-empty-large";
    BxfIconTypeEnum["progress-empty"] = "progress-empty";
    BxfIconTypeEnum["redo"] = "redo";
    BxfIconTypeEnum["refresh"] = "refresh";
    BxfIconTypeEnum["reload"] = "reload";
    BxfIconTypeEnum["remove"] = "remove";
    BxfIconTypeEnum["routes"] = "routes";
    BxfIconTypeEnum["routing-controls"] = "routing-controls";
    BxfIconTypeEnum["running"] = "running";
    BxfIconTypeEnum["save"] = "save";
    BxfIconTypeEnum["search"] = "search";
    BxfIconTypeEnum["sell"] = "sell";
    BxfIconTypeEnum["settings-subtle"] = "settings-subtle";
    BxfIconTypeEnum["settings"] = "settings";
    BxfIconTypeEnum["share"] = "share";
    BxfIconTypeEnum["sigma"] = "sigma";
    BxfIconTypeEnum["split"] = "split";
    BxfIconTypeEnum["steering"] = "steering";
    BxfIconTypeEnum["stepper-down"] = "stepper-down";
    BxfIconTypeEnum["stepper-up"] = "stepper-up";
    BxfIconTypeEnum["success-bold-large"] = "success-bold-large";
    BxfIconTypeEnum["success-bold"] = "success-bold";
    BxfIconTypeEnum["success-subtle-large"] = "success-subtle-large";
    BxfIconTypeEnum["success-subtle"] = "success-subtle";
    BxfIconTypeEnum["table"] = "table";
    BxfIconTypeEnum["team"] = "team";
    BxfIconTypeEnum["template-loaded"] = "template-loaded";
    BxfIconTypeEnum["terminate"] = "terminate";
    BxfIconTypeEnum["text-bold"] = "text-bold";
    BxfIconTypeEnum["text-italic"] = "text-italic";
    BxfIconTypeEnum["text-underline"] = "text-underline";
    BxfIconTypeEnum["thumbs-down"] = "thumbs-down";
    BxfIconTypeEnum["ticker-negative"] = "ticker-negative";
    BxfIconTypeEnum["ticker-positive"] = "ticker-positive";
    BxfIconTypeEnum["undo"] = "undo";
    BxfIconTypeEnum["unlock"] = "unlock";
    BxfIconTypeEnum["up-down"] = "up-down";
    BxfIconTypeEnum["upload"] = "upload";
    BxfIconTypeEnum["uploader-32"] = "uploader-32";
    BxfIconTypeEnum["uploader-68"] = "uploader-68";
    BxfIconTypeEnum["use-workflow-colors"] = "use-workflow-colors";
    BxfIconTypeEnum["visualization"] = "visualization";
    BxfIconTypeEnum["waiting"] = "waiting";
    BxfIconTypeEnum["widget-delete"] = "widget-delete";
    BxfIconTypeEnum["widget-download"] = "widget-download";
    BxfIconTypeEnum["widget-duplicate"] = "widget-duplicate";
    BxfIconTypeEnum["widget-ellipsis"] = "widget-ellipsis";
    BxfIconTypeEnum["widget-export"] = "widget-export";
    BxfIconTypeEnum["widget-filter"] = "widget-filter";
    BxfIconTypeEnum["widget-footnote"] = "widget-footnote";
    BxfIconTypeEnum["widget-link"] = "widget-link";
    BxfIconTypeEnum["widget-maximize"] = "widget-maximize";
    BxfIconTypeEnum["widget-minimize"] = "widget-minimize";
    BxfIconTypeEnum["widget-pin"] = "widget-pin";
    BxfIconTypeEnum["widget-popout"] = "widget-popout";
    BxfIconTypeEnum["widget-refresh"] = "widget-refresh";
    BxfIconTypeEnum["widget-save"] = "widget-save";
    BxfIconTypeEnum["widget-settings"] = "widget-settings";
    BxfIconTypeEnum["widget-size-expand-grow"] = "widget-size-expand-grow";
    BxfIconTypeEnum["widget-size-expand-shrink"] = "widget-size-expand-shrink";
    BxfIconTypeEnum["widget-size-max"] = "widget-size-max";
    BxfIconTypeEnum["widget-size-smaller"] = "widget-size-smaller";
    BxfIconTypeEnum["widget-table"] = "widget-table";
    BxfIconTypeEnum["widget-upload"] = "widget-upload";
    BxfIconTypeEnum["widget-visualization"] = "widget-visualization";
    BxfIconTypeEnum["zoom-in"] = "zoom-in";
    BxfIconTypeEnum["zoom-out"] = "zoom-out";
})(BxfIconTypeEnum || (BxfIconTypeEnum = {}));

const SPIN_ANIMATION = 'spin 1s linear infinite';
const BXF_ICON_CONTAINER = 'bxf-icon__container';
const BXF_ICON_CONTAINER_NO_CURSOR = 'bxf-icon__container--cursor-disabled';
const DISABLED = 'disabled';
const UNDERLINE_HOVER = 'bxf-icon__container--underline-hover';
const BXF_ICON_STROKE = 'bxf-icon__stroke';
const BXF_ICON_FILL = 'bxf-icon__fill';
const BXF_ICON_WITH_TEXT = '-inverted';
// stroke should be filled, fill should be transparent
const ICONS_STROKE_STYLING = new Set([
    'add',
    'alert-subtle',
    'alert-subtle-large',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'bookmark-subtle',
    'buy',
    'checkmark',
    'data-custom-sort',
    'data-filter-a-z',
    'data-filter-large-small',
    'data-filter-small-large',
    'data-filter-z-a',
    'data-select-arrow-down',
    'data-select-arrow-up',
    'did-not-run',
    'favorite-subtle',
    'filter-subtle',
    'help-subtle',
    'info-subtle',
    'info-subtle-large',
    'inprogress-2',
    'inprogress-subtle',
    'inprogress-subtle-large',
    'log-in',
    'log-out',
    'new-subtle',
    'new-subtle-large',
    'play',
    'progress-empty',
    'progress-empty-large',
    'sell',
    'success-subtle',
    'success-subtle-large',
    'unlock',
    'upload',
    'uploader-32',
    'uploader-68',
    'zoom-in',
    'zoom-out',
    'bxf-logo-large',
]);
// fill and stroke should be filled
const ICONS_STROKE_FILL_STYLING = new Set([
    'alert-subtle',
    'alert-subtle-large',
    'buy',
    'data-custom-sort',
    'data-filter-a-z',
    'data-filter-z-a',
    'delete',
    'delete-small',
    'did-not-run',
    'help-subtle',
    'info-subtle',
    'info-subtle-large',
    'log-in',
    'log-out',
    'new-subtle',
    'new-subtle-large',
    'sell',
    'unlock',
    'upload',
    'uploader-32',
    'uploader-68',
    'bxf-arrow-right',
    'bxf-chat-blk-beta',
    'bxf-beta',
    'bxf-send',
    'bxf-kebab-menu',
    'bxf-stop',
    'bxf-chat',
    'bxf-clear',
    'bxf-contact',
    'bxf-copy',
    'bxf-history',
    'bxf-new-chat',
    'bxf-email',
    'bxf-phone',
    'bxf-calendar',
    'bxf-sparkle',
    'bxf-thumbs-down',
    'bxf-thumbs-up',
    'bxf-sparkle-large',
    'bxf-close',
    'bxf-caution48',
]);
// icons with custom svg sizes (svg width and height are not equal 16px)
const CUSTOM_ICON_SIZES = {
    lightbulb: 1.5,
    'action-12': 0.75,
    'alert-bold-large': 1.5,
    'alert-subtle-large': 1.5,
    'favorite-bold-32': 2,
    'info-bold-large': 1.5,
    'info-subtle-large': 1.5,
    'inprogress-bold-large': 1.5,
    'inprogress-subtle-large': 1.5,
    'new-bold-large': 1.5,
    'new-subtle-large': 1.5,
    'progress-active-large': 1.5,
    'progress-empty-large': 1.5,
    'success-bold-large': 1.5,
    'success-subtle-large': 1.5,
    'uploader-32': 2,
    'uploader-68': 4.25,
    'widget-size-expand-grow': 1.0625,
    'copilot-20': 1.25,
    'copilot-32': 2,
    'copilot-64': 4,
    'bxf-arrow-right': 1.125,
    'bxf-chat-blk-beta': 6.875,
    'bxf-loading': 3.5,
    'bxf-loading48': 3,
    'bxf-chat': 3.5,
    'bxf-clear': 1.125,
    'bxf-contact': 2,
    'bxf-dismiss': 2,
    'bxf-history': 2,
    'bxf-kebab-menu': 0.75,
    'bxf-nav-active': 1.5,
    'bxf-nav-inactive': 1.5,
    'bxf-new-chat': 2.438,
    'bxf-email': 0.875,
    'bxf-phone': 1,
    'bxf-panel-logo': 14.75,
    'bxf-calendar': 1,
    'bxf-sparkle': 1.5,
    'bxf-sparkle-large': 2.8125,
    'bxf-thumbs-down': 1.25,
    'bxf-thumbs-up': 1.25,
    'bxf-logo-large': 23.375,
    'bxf-beta': 2.625,
    'bxf-stop': 1.5,
    'bxf-caution48': 3,
    'bxf-pdf': 1.75,
    'bxf-full-screen': 2,
    'bxf-exit-full-screen': 2,
};
const CUSTOM_ICON_HEIGHT = {
    'bxf-arrow-right': 1.125,
    'bxf-chat-blk-beta': 2.75,
    'bxf-loading': 2,
    'bxf-loading48': 3,
    'bxf-chat': 2,
    'bxf-clear': 1.25,
    'bxf-contact': 2,
    'bxf-copy': 1.063,
    'bxf-email': 0.625,
    'bxf-phone': 1,
    'bxf-panel-logo': 3.375,
    'bxf-calendar': 0.875,
    'bxf-dismiss': 2.125,
    'bxf-history': 2,
    'bxf-kebab-menu': 1.3125,
    'bxf-nav-active': 1.5,
    'bxf-nav-inactive': 1.5,
    'bxf-new-chat': 2,
    'bxf-sparkle': 1.5,
    'bxf-sparkle-large': 2.8125,
    'bxf-thumbs-down': 1.313,
    'bxf-thumbs-up': 1.313,
    'bxf-logo-large': 6.625,
    'bxf-stop': 1.5,
    'bxf-caution48': 3,
    'bxf-pdf': 1.5,
    'bxf-full-screen': 2,
    'bxf-exit-full-screen': 2,
};
// icon which should have spin animation by default
const ICONS_WITH_SPIN = new Set([
    BxfIconTypeEnum['loading'],
]);
const BXF_ICON_LOADING = new Set([
    BxfIconTypeEnum['bxf-loading'],
    BxfIconTypeEnum['bxf-loading48'],
]);
const BXF_ICON_UNDERLINE = new Set([
    BxfIconTypeEnum['bxf-thumbs-up'],
    BxfIconTypeEnum['bxf-thumbs-down'],
]);

export { BXF_ICON_CONTAINER as B, CUSTOM_ICON_SIZES as C, DISABLED as D, ICONS_STROKE_STYLING as I, SPIN_ANIMATION as S, UNDERLINE_HOVER as U, BXF_ICON_CONTAINER_NO_CURSOR as a, BXF_ICON_STROKE as b, BXF_ICON_FILL as c, BXF_ICON_WITH_TEXT as d, ICONS_STROKE_FILL_STYLING as e, CUSTOM_ICON_HEIGHT as f, ICONS_WITH_SPIN as g, BXF_ICON_LOADING as h, BXF_ICON_UNDERLINE as i, BxfIconTypeEnum as j };
